import React, { Component } from 'react';

import { requiredString, renderRequired } from '../../utilities/generic/Forms.js'

class PersonFields extends Component {
  // Default value for Personal pages that call PersonFields
  static defaultProps = {
    obfuscatedFields: []
  }

  render() {
    let { email, phone } = this.props;
    const { personal, profile, validator, first_name, last_name, custom_attributes, on_arrival_custom_attributes, autocompleteLock, obfuscatedFields, missingRequiredFields, missingRequiredCustomAttributes, handleChange, resetObfuscatedField, handleCustomAttributeChange} = this.props;

    const disableFields = profile.disable_auto_create && autocompleteLock

    email = obfuscatedFields.includes("email") ? this.obscureEmail(email) : email
    phone = obfuscatedFields.includes("phone") ? this.obscurePhone(phone) : phone

    return (
      <>
        { profile.first_name_used &&
          <label className="bottom-margin">
            <div className="text">{(profile.first_name_called) ? profile.first_name_called : "First Name"}{renderRequired(profile.first_name_required)}</div>
            <input aria-required="true" type="text" name="first_name" value={first_name} autoComplete={personal ? "given-name" : "off"} onChange={handleChange} disabled={disableFields && !missingRequiredFields.includes("first_name")} />
            <div className="blank"></div>
            {validator.message('first_name', first_name, requiredString(profile.first_name_required, "string"), { className: 'error' })}
          </label>
        }

        { profile.last_name_used &&
          <label className="bottom-margin">
            <div className="text">{(profile.last_name_called) ? profile.last_name_called : "Last Name"}{renderRequired(profile.last_name_required)}</div>
            <input aria-required="true" type="text" name="last_name" value={last_name} autoComplete={personal ? "family-name" : "off"} onChange={handleChange} disabled={disableFields && !missingRequiredFields.includes("last_name")} />
            <div className="blank"></div>
            {validator.message('last_name', last_name, requiredString(profile.last_name_required, "string"), { className: 'error' })}
          </label>
        }

        { profile.email_used &&
          <label className="bottom-margin">
            <div className="text">{(profile.email_called) ? profile.email_called : "Email Address"}{renderRequired(profile.email_required)}</div>
            {obfuscatedFields.includes("email") ? (
              // Skip "email" validation when data has asterisks in it from obfuscation
              <>
                <input aria-required="true" type="text" name="email" value={email} autoComplete={personal ? "email" : "off"} onChange={handleChange} onFocus={resetObfuscatedField} disabled={disableFields && !missingRequiredFields.includes("email")} />
                <div className="blank"></div>
                {validator.message('email', email, requiredString(profile.email_required, "string"), { className: 'error' })}
              </>
            ) : (
              <>
                <input aria-required="true" type="email" name="email" value={email} autoComplete={personal ? "email" : "off"} onChange={handleChange} onFocus={resetObfuscatedField} disabled={disableFields && !missingRequiredFields.includes("email")} />
                <div className="blank"></div>
                {validator.message('email', email, requiredString(profile.email_required, "email"), { className: 'error' })}
              </>
            )}
          </label>
        }

        { profile.phone_used &&
          <label className="bottom-margin">
            <div className="text">{(profile.phone_called) ? profile.phone_called : "Phone Number"}{renderRequired(profile.phone_required)}</div>
            <input aria-required="true" type="tel" name="phone" value={phone} autoComplete={personal ? "tel" : "off"} onChange={handleChange} onFocus={resetObfuscatedField} disabled={disableFields && !missingRequiredFields.includes("phone")} />
            <div className="blank"></div>
            {autocompleteLock === false ? (
              validator.message('phone', phone, requiredString(profile.phone_required, "phone"), { className: 'error' })
            ) : (
              // Skip "phone" validation when data is populated from autocomplete
              validator.message('phone', phone, requiredString(profile.phone_required, "string"), { className: 'error' })
            )}
          </label>
        }

        {on_arrival_custom_attributes && on_arrival_custom_attributes.map((attribute) => (
          <label className="bottom-margin" key={attribute.id}>
            <div className="text">{attribute.name}{renderRequired(true)}</div>
            <input aria-required="true" type="text" name={attribute.id} value={custom_attributes[attribute.id] || ""} autoComplete={personal ? "given-name" : "off"} onChange={handleCustomAttributeChange} disabled={disableFields && !missingRequiredCustomAttributes.includes(attribute.id)} />
            <div className="blank"></div>
            {validator.message(attribute.name, custom_attributes[attribute.id], requiredString(true, "string"), { className: 'error' })}
          </label>
        ))}

        <div className="red">* Required fields.</div>
      </>
    )
  }

  obscurePhone(phone) {
    return this.obscureCharacters(2, phone)
  }

  obscureEmail(email) {
    if (email === undefined || email === null) {
      return ""
    }

    if (!email.includes("@") || !email.includes(".")) {
      return this.obscureCharacters(2, email)
    }

    const [address, domain] = email.split("@")
    let domainFragments = domain.split(".")
    const finalDomain = domainFragments.pop()

    return this.obscureCharacters(2, address) + "@" + domainFragments.map(string => this.obscureCharacters(1, string)).join(".") + "." + finalDomain
  }

  obscureCharacters(showCharacters, string) {
    if (string === undefined || string === null) {
      return ""
    }

    if (string.length <= showCharacters * 2) {
      if (string.length > 2) {
        showCharacters = 1
      }
      else {
        return string;
      }
    }

    const asterisksCount = string.length - (showCharacters * 2)

    const start = string.slice(0, showCharacters)
    const end = string.slice(-showCharacters);
    const asterisks = "*".repeat(asterisksCount)

    return start + asterisks + end
  }
}

export default PersonFields;
